export default {
  Providers: {
    App: 'providers.app',
    TokenLists: 'providers.tokenLists',
    Tokens: 'providers.tokens'
  }
};
